module.exports = __webpack_public_path__ + "static/media/1020627.481cd582.png";